module.exports = __webpack_public_path__ + "img/itx-file-type-one.32548cb4.svg";